import { Fragment } from 'react'
import { Flex, type FlexProps, Text } from '@chakra-ui/react'

import { ChevronDownIcon } from '@/components/icons/ChevronDown'

interface BreadcrumbItem {
  label: string
  onClick?: () => void
}

interface BreadcrumbsProps extends Omit<FlexProps, 'children'> {
  items: BreadcrumbItem[]
  color?: string
}

export default function Breadcrumbs({
  items,
  color = 'white',
  ...flexProps
}: BreadcrumbsProps) {
  return (
    <Flex align="center" gap="10px" {...flexProps}>
      {items.map((item, index) => {
        const isLast = index === items.length - 1

        return (
          <Fragment key={item.label}>
            {index > 0 && (
              <ChevronDownIcon
                boxSize="10px"
                color={color}
                transform="rotate(-90deg)"
              />
            )}
            <Text
              {...(item.onClick && {
                as: 'button',
                type: 'button',
                onClick: item.onClick
              })}
              textStyle="breadcrumb"
              color={color}
              cursor={item.onClick ? 'pointer' : 'default'}
              opacity={isLast ? 0.8 : 1}
              fontWeight={isLast ? 400 : undefined}
              background="none"
              border="none"
              padding="0"
            >
              {item.label}
            </Text>
          </Fragment>
        )
      })}
    </Flex>
  )
}
